module.exports = __webpack_public_path__ + "img/sdg_en_(10).3e63948f.png";